import styled from "styled-components";
import { satoshi500 } from "../../../../../../styles/font.constants";

export const PollOption = styled.div`
	display: flex;
	flex-direction: column;
	margin: 0.8rem 0;
`;

export const PollLabelRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	${satoshi500}
	font-size: 0.75rem;
	margin-bottom: 0.3rem;
`;
